import * as types from './action-types';
// import { PanelProxy } from '../../../proxies';

const calcReservationCredit = (payload) => {
  return dispatch => new Promise((resolve, reject) => {
    dispatch({ type: types.CALC_RESERVATION_CREDIT, payload: { data: { ...payload }, key: 'reservationCredit' } });
  });
};

const setEditBookData = (payload) => {
  return dispatch => new Promise((resolve, reject) => {
    dispatch({ type: types.SET_SINGLE_RESERVATION_DATA, payload: { data: { ...payload }, key: 'editBookData' } });
  });
};

const clearData = (payload) => {
  return dispatch => new Promise((resolve, reject) => {
    dispatch({ type: types.SET_SINGLE_RESERVATION_DATA, payload: { data: { ...payload}, key: 'reservationList' } });
  });
};


export default {
  calcReservationCredit,
  setEditBookData,
  clearData
}



// WEBPACK FOOTER //
// ./src/store/modules/reservation/actions.js